
import {defineComponent, PropType} from 'vue'
import {PagerLinkItem} from "@/types";
import {mapActions} from "vuex";

export default defineComponent({
    name: "PagerLinkItem",
    props: {
        pagerItem: {
            type: Object as PropType<PagerLinkItem>,
            required: true,
        },
        key: {
            type: String,
            required: true,
        }
    },
    methods: {
        ...mapActions({
            loadProducts: 'LOAD_PRODUCTS',
        }),
        changePage(url: string) {
            this.loadProducts({url: url});
        },
    }
})
